/**
 * @fileoverview GET handler for the "/:app_group_id/campaign_brief/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { isGetBriefResult } from "../briefShared";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { campaignBrief } from "./constants";
import type { GetCampaignBriefProps, GetCampaignBriefResult } from "./types";

export const getCampaignBrief = reactQueryFetcherAdapter(
  campaignBrief,
  (signal: AbortSignal, { appGroupId, campaignId }: GetCampaignBriefProps): Promise<GetCampaignBriefResult> => {
    return fetch(
      `/${appGroupId}/campaign_brief/${campaignId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetBriefResult
);
